export const INLINE = 'inline';
export const EDIT = 'edit';